export const formatImageUrl = (imageUrl?: string) => {
  if (!imageUrl) {
    return '';
  }

  if (imageUrl.endsWith('/')) {
    imageUrl = imageUrl.slice(0, -1);
  }

  return imageUrl + '/-/format/jpg/';
};
